import { API_URL } from 'utils/constants/app';
import { RequestHelper } from 'utils/helpers/RequestHelper';

const programServiceUrl = `${API_URL}/program`;

const getProgramsByLaboratoryId = laboratoryId => RequestHelper.GET(`${programServiceUrl}/${laboratoryId}`);

const getAllProgramsNames = () => RequestHelper.GET(`${programServiceUrl}/list`);

export const ProgramService = {
  getProgramsByLaboratoryId,
  getAllProgramsNames
};